import React from 'react';
import DisciplineList from '../../components/disciplinas/DisciplinesList';
import { listDisciplines } from '../../services/academic';
import { Link } from 'react-router-dom';
import withCards from 'hoc/withCards';

const ListDisciplinesPage = ({ ...props }) => {
  return (
    <>
      <div className="mb-3">
        <Link className="btn btn-primary" to="/disciplinas/new">
          Criar Disciplina
        </Link>
      </div>
      <DisciplineList {...props} onChangeFilter={(e) => listDisciplines(e)} />
    </>
  );
};

export default withCards({
  fetch: listDisciplines,
  title: 'Lista de Disciplinas',
  paginated: true,
  noResultsText: 'Nenhuma disciplina foi encontrada.',
})(ListDisciplinesPage);
